module.exports = __webpack_public_path__ + "static/img/training_system_s2_max2.466350ea.png";